import Resource from './Resource'

/**
 * Tag Resource
 */
class Tag extends Resource
{
    constructor() {
        super('tag', ['tags']);
    }

    attach(tag, taggable) {
        let data = { taggable }

        if (tag.id) {
            data.tag_id = tag.id
        } else if(tag.name) {
            data.tag_name = tag.name
        }

        return this._doPost('attach', data)
    }

    detach(tag, taggable) {
        let data = { taggable }

        if (tag.id) {
            data.tag_id = tag.id
        } else if(tag.name) {
            data.tag_name = tag.name
        }

        return this._doPost('detach', data)
    }
}   

export let TagResource = new Tag();

/**
 * TagSchema
 * @param {Object} defaults [description]
 */
export let TagSchema = function(defaults = {}) {
    let schema = {
        id: null,
        name: null
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}